import { HUBSPOT_DEFINED } from 'automation-ui-associations/constants/AssociationCategory';
import { SAME_OBJECT_ASSOCIATION_ENROLLED_OBJECT } from 'automation-ui-references/object-types/CRMObjectTypes';

/**
 * With same object associations, associations will always be object types other
 * than the enrolled object.
 */
export const getIsAssociationWithSameObjectAssociations = sameObjectAssociationObjectTypeId => sameObjectAssociationObjectTypeId !== SAME_OBJECT_ASSOCIATION_ENROLLED_OBJECT;
/**
 * If we encounter 'enrolled_object', we know we want
 * the flowObjectTypeId
 */
export const translateSameObjectAssociationObjectTypeId = ({
  sameObjectAssociationObjectTypeId,
  flowObjectTypeId
}) => sameObjectAssociationObjectTypeId === SAME_OBJECT_ASSOCIATION_ENROLLED_OBJECT ? flowObjectTypeId : sameObjectAssociationObjectTypeId;
export const getIsParentChildCompanyAssociation = ({
  associationDefinition
}) => {
  const isParentCompanyAssociation = associationDefinition.id === 14 && associationDefinition.category === HUBSPOT_DEFINED;
  const isChildCompanyAssociation = associationDefinition.id === 13 && associationDefinition.category === HUBSPOT_DEFINED;
  return isParentCompanyAssociation || isChildCompanyAssociation;
};